import { styled } from '@linaria/react';
import { colors, layout } from '../../theme/tokens';

export const Block = styled.div`
  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }

  background: linear-gradient(
    90deg,
    ${colors.offWhite} 25%,
    ${colors.lightGrey} 50%,
    ${colors.offWhite} 75%
  );
  background-size: 800px 100%;
  animation: shimmer 1.4s ease-in-out infinite;
  border-radius: ${layout.borderRadius};
  display: block;
`;
